<!-- Dashboard Page Layout Section Code Start -->
<div class="dashboard-page">

    <div class="container">
      <div class="dashboard-section">
        <div class="dashboard-section-title">
          <h2 class="heading-level-2 blue-color">Simulations</h2>
          <div class="dashboard-button-group">
            <button class="dashboard-user-button" (click)="toggleExpired()"
            [attr.aria-label]="showExpired ? 'Hide Expired clickable' : 'Show Expired clickable'">
              <ng-container *ngIf="showExpired; else showTemplate">
                <span aria-live="assertive"><img src="/assets/images/hide_icon_white.svg" alt="Hide" />Hide Expired</span>
              </ng-container>
              <ng-template #showTemplate>
                <span aria-live="assertive"><img src="/assets/images/show_icon_white.svg" alt="Show" />Show Expired</span>
              </ng-template>
            </button>

            <button *ngIf="role=='Admin'" class="dashboard-user-button" (click)="AddNewSession()"><img src="/assets/images/user_plus.svg" 
                alt="Add New Simulation" /> Add New Simulation </button>
            <button *ngIf="role!='Instructor'" class="dashboard-user-button" (click)="FindUser()"><img src="/assets/images/user_search.svg"
                alt="Find User" /> Find User</button>
          </div>
        </div>
  
        <!-- Dashboard Page Table Section Code Start -->
        <div class="dashboard-table-block">
          <table class="dashboard-table-section">
            <thead>
              <tr>
                <th (click)="sortData('name')">Name <span [ngClass]="getSortDirection('name')"></span></th>
                <!-- commenting out these th because these value are not getting read from ts file, and causing NVDA issue -->
                <!-- <th>&nbsp;</th>
              <th>&nbsp;</th> -->
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let worksession of worksessions ; let index = index">
                <ng-container *ngIf="(showExpired && worksession.time_remaining === 'Expired') || (!showExpired && worksession.time_remaining !== 'Expired')">
                  <td data-title="Name" class="name1"><a href="javascript:void(0)"
                      (click)="AdminControlPage(worksession)">{{worksession.name}}</a></td>
                      <!-- commenting out these td because these value are not getting read from ts file, and causing NVDA issue -->
                  <!-- <td data-title="Quarter">{{worksession.quarter}}</td>
                  <td class="align-center expire-label" data-title="Time Remaining">{{worksession.time_remaining}}</td> -->

                </ng-container>
              </tr>
  
          </table>
        </div>
        <!-- Dashboard Page Table Section Code End -->
      </div>
    </div>
  
  </div>
  <!-- Dashboard Page Layout Section Code End -->
  
  <!-- Delete Modal Code -->
  <div id="customPopup" class="modal">
    <div class="modal-content">
      <div class="modal-main-content">
        <button class="close delete-close" id="closeButton"><img src="/assets/images/close_circle.svg" alt="Close"></button>
        <h2 class="modal-heading center">{{ KeyValue.delete_session_confirm }}</h2>
        <div class="button-container button-container-center">
          <button class="modal-button yes-button" id="deleteButton">Yes</button>
          <button class="modal-button delete-close" id="cancelButton">Cancel</button>
        </div>
      </div>
    </div>
  </div>
  
  <div id="customPopup1" class="modal">
    <div class="modal-content modal-delete-simlution">
      <div class="modal-main-content">
        <button class="close delete-close" id="closeButton1"><img src="/assets/images/close_circle.svg" alt="Close"></button>
        <h2 class="modal-heading center">Wait!!!!. Simulation is in progress.</h2>
        <div class="button-container button-container-center">
          <button class="modal-button delete-close" id="deleteButton1">Ok</button>
        </div>
      </div>
    </div>
  </div>
  
  <!-- Add Simulation Modal -->
  <div id="add-simulation-modal" class="modal black-shadow">
    <div class="modal-content">
      <div class="modal-main-content">
        <button class="close add-simulation-close" id="closeAddSimulation"><img src="/assets/images/close_circle.svg"
            alt="Close"></button>
        <h2 class="modal-heading">Add New Simulation</h2>
        <form class="form-horizontal" #courseForm="ngForm" (ngSubmit)="submit()">
          <div class="add-simulation-field">
            <input type="text" placeholder="Enter Simulation Name" id="name" [(ngModel)]="session_name"
              name="session_name">
          </div>
          <div class="button-container button-container-right">
            <button class="modal-button yes-button" type="submit">Create & Edit</button>
            <button class="modal-button add-simulation-close" id="cancelAddSimulation" type="button">Cancel</button>
          </div>
          <div *ngIf="error_message" class="errormsg" role="alert">
            {{error_message}}</div>
        </form>
      </div>
    </div>
  </div>